import { ModelBase } from 'store/model-base';

export class CmsCallFromUS extends ModelBase {
    public static storeName: string = 'cmsCallFromUS';

    public title: string;
    public subtitle: string;
    public cardTitle: string;
    public mexCanIcon: CmsMediaImage;
    public inUseIcon: CmsMediaImage;
    public searchRatesLink: string;
    public searchRatesLinkCta: string;
    public supportHeader: string;
    public supportLinks: string[];
    public callFromUSContent: CallFromUSContent[];
}
